import { useNavigate } from "react-router-dom";
import { CreditCard } from "lucide-react";
import { useUserMemberships } from "@/hooks/useUserMemberships";
import { useAuth } from "@/hooks/useAuth";
import ServiceWithPromotion from "./ServiceWithPromotion";

interface Service {
  id: string;
  name: string;
  duration_minutes: number;
  description: string;
  price: number;
}

interface ServicesTabProps {
  services: Service[] | undefined;
  providerName: string;
  providerId?: string;
  selectedDate?: Date;
}

const ServicesTab = ({
  services,
  providerName,
  providerId,
  selectedDate
}: ServicesTabProps) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data: userMemberships, isLoading: membershipsLoading } = useUserMemberships(providerId);

  const hasActiveMembership = userMemberships && userMemberships.length > 0;
  
  const handleServiceSelect = (serviceId: string) => {
    if (providerId) {
      navigate(`/booking/${providerId}/${serviceId}`);
    }
  };

  if (!services || services.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <p>No services available at the moment.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {user && hasActiveMembership && (
        <div className="bg-accent/50 border border-border rounded-xl p-4 mb-4">
          <div className="flex items-center gap-2">
            <CreditCard className="h-4 w-4 text-foreground" />
            <p className="text-foreground text-sm font-medium">You have credits available</p>
          </div>
        </div>
      )}

      {services.map(service => (
        <ServiceWithPromotion
          key={service.id}
          service={service}
          providerName={providerName}
          selectedDate=""
          onSelect={handleServiceSelect}
        />
      ))}
    </div>
  );
};

export default ServicesTab;
